import { accessibilityEvent } from 'backend/eventFirings.jsw';
import wixUsers from 'wix-users';
import wixWindow from 'wix-window';
import wixLocation from 'wix-location';
let formFactor = wixWindow.formFactor;
const LINKS = {
    home: "https://www.wix.com",
    about: "https://www.wix.com/about/us"
}
$w.onReady(() => {
    $w("#vectorImage20").show();
    $w('#vectorImage20').onClick((handler) => {
        wixLocation.to(wixLocation.baseUrl);
    });
});

async function fireEvent() {
    const distinctId = wixUsers.currentUser.id;
    const initialReferrer = wixWindow.referrer || null;
    let initialDomainReferrer = null;
    let jobClientReferrer = null;
    if (initialReferrer) {
        initialDomainReferrer = wixWindow.referrer.substr(8, wixWindow.referrer.indexOf('.'));
        jobClientReferrer = wixWindow.referrer.substr(8, wixWindow.referrer.indexOf('.'));
    }
    const jobClientSessionId = '4e05c5cc-8ce7-449d-8d90-7cc6687e2df7';
    const jobsPageName = $w("#page").title

    accessibilityEvent(initialReferrer, initialDomainReferrer, jobClientReferrer, jobClientSessionId, jobsPageName);
}
export function urlMouseIn(event) {
    let linkId = event.target.id;
    $w("#" + linkId).html = changeUrlColor('#0067ff', $w("#" + linkId).text, LINKS[linkId])
}
export function urlMouseOut(event) {
    let linkId = event.target.id;
    $w("#" + linkId).html = changeUrlColor('#000000', $w("#" + linkId).text, LINKS[linkId])
}

function changeUrlColor(color, text, url) {
    return `<a  href="${url}" style = "font-size:16px;color:${color};font-family:wfont_5a7e24_f87b856372b14196859521352e602c67,wf_f87b856372b14196859521352,orig_helvetica_neue_w_01_45_light;"> ${text}</a>`;
}
export function mobileHamurgerButton_click(event) {
	$w('#searchIcon').collapse()
    $w('#searchInputBox').collapse()
    $w('#mobileHamurgerButton').hide()
    $w('#closeMenuButton').show()
    $w('#mobileBox').show() 
}

export function closeMenuButton_click(event) {
	$w('#mobileHamurgerButton').show()
    $w('#closeMenuButton').hide()
    $w('#mobileBox').hide()
    $w('#searchIcon').expand()
    $w('#searchInputBox').expand() 
}